(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trDashboard', trDashboard);

  function trDashboard() {
    const directive = {
      restrict: 'E',
      scope: {},
      controller: 'DashboardController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/dashboard/dashboard.view.html'
    };
    return directive;
  }
})();
